document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector("form#estimation-form")
    if (!container) return

    container.querySelectorAll('[data-cell-role="destroy"]').forEach(cell => cell.remove())
})
